import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as rate from '../rate'

const page = prebuilt.Page.get(prebuilt.Page.Id.RateReports)

export const RESOURCE = {
  payload: {
    alias: 'reports',
    appAlias: rate.RESOURCE.payload.alias,
    description: page.description,
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Reports',
    page: { id: prebuilt.Page.Id.RateReports },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
